<!-- src/app/meter/components/meter-analytics/meter-kpi-cards/meter-kpi-cards.component.html -->

<div class="kpi-cards" *ngIf="snapshot">
    <!-- Total Linked Meters -->
    <div class="kpi-card">
        <div class="kpi-label">{{ 'meter.analytics.kpi_total_linked' | translate }}</div>
        <div class="kpi-value">{{ snapshot.totalLinkedMeters }}</div>
        <div class="kpi-subtitle" *ngIf="getDelta(snapshot.totalLinkedMeters, snapshot.previousTotalLinkedMeters) as delta"
             [class.positive]="delta > 0" [class.muted]="delta === 0">
            <span *ngIf="delta > 0">&#9650; +{{ delta }}</span>
            <span *ngIf="delta === 0">—</span>
            {{ 'meter.analytics.vs_previous' | translate }}
        </div>
    </div>

    <!-- Linkage Rate -->
    <div class="kpi-card">
        <div class="kpi-label">{{ 'meter.analytics.kpi_linkage_rate' | translate }}</div>
        <div class="kpi-value">{{ snapshot.linkageRate }}%</div>
        <div class="kpi-subtitle" *ngIf="getDelta(snapshot.linkageRate, snapshot.previousLinkageRate) as delta"
             [class.positive]="delta > 0" [class.muted]="delta === 0">
            <span *ngIf="delta > 0">&#9650; +{{ delta }}%</span>
            <span *ngIf="delta === 0">—</span>
            {{ 'meter.analytics.vs_previous' | translate }}
        </div>
    </div>

    <!-- Active Meters -->
    <div class="kpi-card">
        <div class="kpi-label">{{ 'meter.analytics.kpi_active_meters' | translate }}</div>
        <div class="kpi-value">{{ snapshot.activeMeters }}</div>
        <div class="kpi-subtitle" *ngIf="getDelta(snapshot.activeMeters, snapshot.previousActiveMeters) as delta"
             [class.positive]="delta > 0" [class.negative]="delta < 0" [class.muted]="delta === 0">
            <span *ngIf="delta > 0">&#9650; +{{ delta }}</span>
            <span *ngIf="delta < 0">&#9660; {{ delta }}</span>
            <span *ngIf="delta === 0">—</span>
            {{ 'meter.analytics.vs_previous' | translate }}
        </div>
    </div>

    <!-- Total Consumption -->
    <div class="kpi-card">
        <div class="kpi-label">{{ 'meter.analytics.kpi_total_consumption' | translate }}</div>
        <div class="kpi-value">{{ snapshot.totalConsumption }} {{ 'meter.analytics.unit_m3' | translate }}</div>
        <div class="kpi-subtitle" *ngIf="getDelta(snapshot.totalConsumption, snapshot.previousTotalConsumption) as delta"
             [class.muted]="true">
            <span *ngIf="delta > 0">&#9650; +{{ delta }}</span>
            <span *ngIf="delta < 0">&#9660; {{ delta }}</span>
            <span *ngIf="delta === 0">—</span>
            {{ 'meter.analytics.unit_m3' | translate }} {{ 'meter.analytics.vs_previous' | translate }}
        </div>
    </div>

    <!-- Avg Consumption / Meter -->
    <div class="kpi-card">
        <div class="kpi-label">{{ 'meter.analytics.kpi_avg_consumption' | translate }}</div>
        <div class="kpi-value">{{ snapshot.avgConsumptionPerMeter }} {{ 'meter.analytics.unit_m3' | translate }}</div>
        <div class="kpi-subtitle" *ngIf="getDelta(snapshot.avgConsumptionPerMeter, snapshot.previousAvgConsumptionPerMeter) as delta"
             [class.muted]="true">
            <span *ngIf="delta > 0">&#9650; +{{ delta }}</span>
            <span *ngIf="delta < 0">&#9660; {{ delta }}</span>
            <span *ngIf="delta === 0">—</span>
            {{ 'meter.analytics.unit_m3' | translate }} {{ 'meter.analytics.vs_previous' | translate }}
        </div>
    </div>

    <!-- Alerts Triggered -->
    <div class="kpi-card">
        <div class="kpi-label">{{ 'meter.analytics.kpi_alerts_triggered' | translate }}</div>
        <div class="kpi-value" [class.danger]="snapshot.alertsTriggered > 0">{{ snapshot.alertsTriggered }}</div>
        <div class="kpi-subtitle" *ngIf="getDelta(snapshot.alertsTriggered, snapshot.previousAlertsTriggered) as delta"
             [class.negative]="delta > 0" [class.positive]="delta < 0" [class.muted]="delta === 0">
            <span *ngIf="delta > 0">&#9650; +{{ delta }}</span>
            <span *ngIf="delta < 0">&#9660; {{ delta }}</span>
            <span *ngIf="delta === 0">—</span>
            {{ 'meter.analytics.vs_previous' | translate }}
        </div>
    </div>
</div>
